export const GoogleMap = ({ className = '' }) => {
  return (
    <div
      className={`w-full rounded-2xl overflow-hidden shadow-lg ${className}`}
      data-testid="google-map"
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.123456789!2d0.7134!3d45.1847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47fe0d5ca92f7d5b%3A0x123456789abcdef!2s2%20Rue%20Ludovic%20Trarieux%2C%2024000%20P%C3%A9rigueux!5e0!3m2!1sfr!2sfr!4v1234567890"
        width="100%"
        height="400"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Localisation - Éveil Musical Charlotte Naboulet"
      />
    </div>
  );
};
